import {
  select,
  fork,
  put,
  all,
  call,
  takeEvery,
  takeLatest,
} from 'redux-saga/effects'

import {
  updateTablesAction,
  clearTables,
} from 'containers/Entity/actions'

import {
  get,
  post
} from 'helpers/RequestUtil'

import {
  UPDATE_ACTIVE_DIALOG
} from 'containers/Admin/Product/Product/constants'

import {
  FETCH_PRODUCT_ROLES,
  POST_PRODUCT_ROLES,
} from './constants'

import {
  selectedSelector,
} from 'containers/Admin/Product/ProductSelection/selectors'

import {
  productRolesSelector,
  productRolesChanges,
} from './selectors'

import {
  updateProductRoles,
  updateProductRolesChange,
  fetchProductRolesStart,
  fetchProductRolesSuccess,
  fetchProductRolesError,
  postProductRolesStart,
  postProductRolesSuccess,
  postProductRolesError,
} from './actions'

function* fetchProductRoles(productId) {
  try {
    yield put(fetchProductRolesStart())
    const data = yield call(get, `/api/fulcrum/products/${productId}/roles`)
    const { result: { product_roles: roles } } = data
    yield put(updateTablesAction(data))
    yield put(fetchProductRolesSuccess())
    return roles
  } catch(error) {
    yield put(fetchProductRolesError(error))
  }
}

function* postProductRoles(productId, team) {
  try {
    yield put(postProductRolesStart())
    const postRequest = post('roles', { team, productId })
    yield call(postRequest, `/api/fulcrum/products/${productId}/roles`)
    yield put(postProductRolesSuccess())
  } catch(error) {
    yield put(postProductRolesError(error))
  }
}

function* handleFetchProductRoles() {
  const { productId } = yield select(selectedSelector)
  const roles = yield call(fetchProductRoles, productId)
  yield put(updateProductRoles(roles))
  const team = yield select(productRolesSelector)
  yield put(updateProductRolesChange(team))
}

function* handlePostProductRoles(action) {
  const { productId } = yield select(selectedSelector)
  const team = yield select(productRolesChanges)
  yield call(postProductRoles, productId, team)
}

function * handleEditProductRole(action) {
  const { active } = action
  if (active) {
    yield call(handleFetchProductRoles)
  }
}

function* watchEditProductRole() {
  yield takeLatest(UPDATE_ACTIVE_DIALOG, handleEditProductRole)
}

function* watchFetchProductRoles() {
  yield takeEvery(FETCH_PRODUCT_ROLES, handleFetchProductRoles)
}

function* watchPostProductRoles() {
  yield takeEvery(POST_PRODUCT_ROLES, handlePostProductRoles)
}

function* loadSagas() {
  yield all([
    fork(watchFetchProductRoles),
    fork(watchPostProductRoles),
    fork(watchEditProductRole),
  ])
}

export default loadSagas
